import React from 'react';
import { IToggleProps, Toggle } from '@fluentui/react';

export const EHToggle = (props: IToggleProps): JSX.Element => {
  return <Toggle {...props} />;
};
